import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';

var EMPTY_ANCHOR_ATTR = {};
var useHeaderBrandLogo = function useHeaderBrandLogo(brandLogo) {
  var logoIsSeperated = _Array$isArray(brandLogo);
  if (logoIsSeperated) {
    var _brandLogo = _slicedToArray(brandLogo, 2),
      _brandLogo$ = _brandLogo[0],
      nLogo = _brandLogo$ === void 0 ? EMPTY_ANCHOR_ATTR : _brandLogo$,
      _brandLogo$2 = _brandLogo[1],
      payLogo = _brandLogo$2 === void 0 ? EMPTY_ANCHOR_ATTR : _brandLogo$2;
    return {
      nLogo: nLogo,
      payLogo: payLogo
    };
  }
  return {
    npayLogo: brandLogo
  };
};

export { useHeaderBrandLogo as default };
